import { Component } from '@angular/core';
import { State } from '../../../../../shared/interfaces/state.interface';
import { GameService } from '../../../../../shared/services/game.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UrlConstants } from '../../../../../shared/constants/urlparams.constants';
import { GeneralConstants } from '../../../../../shared/constants/general.constants';

import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent {
  get faSignOutAlt() { return faSignOutAlt };
  get faUser() { return faUser };
  get maxPlayerCount() { return GeneralConstants.MaxPlayerCount; };

  gameName: string = this.getGameName();
  playerCount: number = 0;

  constructor(private route: ActivatedRoute, private router: Router, private gameService: GameService) {
    this.gameService.stateUpdateReceived$.subscribe((state: State) => {
      this.playerCount = state.Players.length;
    });
  }

  leaveGame() {
    this.router.navigateByUrl("/");
  }


  private getGameName() {
    return atob(decodeURI(this.route.snapshot.paramMap.get(UrlConstants.GameName)));
  }
}
